import * as React from "react";
const SvgFileUpload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5rem"
    height="5rem"
    fill="currentColor"
    viewBox="0 0 72 70"
    {...props}
  >
    <path
      fill="#BCD0FA"
      fillRule="evenodd"
      d="M6 2a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm0-2h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6Z"
      clipRule="evenodd"
      opacity={0.3}
    />
    <rect
      width={48}
      height={48}
      x={8}
      y={8}
      fill="#2466EA"
      opacity={0.1}
      rx={2}
    />
    <circle cx={60} cy={58} r={12} fill="#BCD0FA" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M61.213 63.596a1 1 0 0 1-2 0v-8l-2.669 2.668a1.004 1.004 0 1 1-1.42-1.42l5.032-5.03a.081.081 0 0 1 .114 0l5.032 5.03a1.004 1.004 0 0 1-1.42 1.42l-2.67-2.668v8Z"
      clipRule="evenodd"
    />
    <circle cx={21} cy={26} r={8} fill="#BCD0FA" />
    <path fill="#fff" d="M22 26h17v17H22z" />
    <path
      fill="#BCD0FA"
      fillRule="evenodd"
      d="m43 30 8 16H35l8-16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFileUpload;
